import { assetTag1, assetTag2, assetTag3, twinTracker2, twinTracker3 } from '@assets/images/main/rtls/product';
import productImg from './productImg';
import {
  tagUwb1Pop,
  tagUwb2Pop,
  tagUwb3Pop,
  twinTrackerBle1Pop,
  twinTrackerBle2Pop,
  twinTrackerBle3Pop,
  twinTrackerBracket1Pop,
  twinTrackerBracket2Pop,
  twinTrackerBracket3Pop,
  twinTrackerUwb1,
  twinTrackerUwb2,
  twinTrackerUwb3,
} from '@assets/images/main';
export default {
  products: [
    { title: 'accesscontroller', components: [{ part: 0 }, { part: 1 }] },

    {
      title: 'accessauto',
      components: [{ part: 0 }, { part: 1 }, { part: 2 }],
    },

    {
      title: 'accesspro',
      components: [{ part: 0 }, { part: 1 }, { part: 2 }],
    },
    {
      title: 'assetTracking',
      components: [{ part: 3 }, { part: 4 }, { part: 5 }],
    },
    {
      title: 'workerTracking',
      components: [{ part: 6 }, { part: 7 }, { part: 5 }],
    },
  ],

  parts: [
    {
      title: 'Khóa điện từ (EM Lock)',
      serial: 'EM-Lock',
      desc: 'Thiết bị khóa điện từ được sử dụng chủ yếu cho cửa một chiều như cửa chống cháy hoặc cửa gỗ không phải là cửa tự động, sử dụng lực từ để giữ chặt cửa.',
      price: '150,000',
      img: [
        { data: productImg.product.emlock.mini1 },
        { data: productImg.product.emlock.mini2 },
        { data: productImg.product.emlock.mini3 },
        { data: productImg.product.emlock.mini4 },
      ],
    },
    {
      title: 'Khóa chốt chết (Deadbolt)',
      serial: 'Deadbolt Lock',
      desc: 'Khóa deadbolt tự động khóa khi đóng cửa. Phù hợp sử dụng cho cửa ra vào của căn hộ, văn phòng, cổng chính,... với tính năng khóa tự động.',
      price: '150,000',
      img: [
        { data: productImg.product.deadbolt.mini1 },
        { data: productImg.product.deadbolt.mini2 },
        { data: productImg.product.deadbolt.mini3 },
        { data: productImg.product.deadbolt.mini4 },
      ],
    },
    {
      title: 'Cảm biến cửa tự động trong nhà',
      serial: 'Automatic Door Sensor',
      desc: 'Thiết bị cảm biến hiệu suất cao phát hiện chuyển động của người hoặc vật thể, điều khiển hoạt động đóng/mở cửa tự động.',
      price: '99,000',
      img: [
        { data: productImg.product.accessauto.mini1 },
        { data: productImg.product.accessauto.mini2 },
        { data: productImg.product.accessauto.mini3 },
        { data: productImg.product.accessauto.mini4 },
      ],
    },
    {
      title: 'Thẻ tài sản (Asset Tag - BLE)',
      serial: 'OAS-OTBT1991',
      desc: 'Dễ dàng gắn vào để theo dõi vị trí tài sản.',
      price: '30,000',
      img: [{ data: productImg.product.bleStarterKit.mini2 }, { data: assetTag1 }, { data: assetTag2 }, { data: assetTag3 }],
    },
    {
      title: 'TwinTracker (BLE)',
      serial: 'OTR-TTBT0001',
      desc: 'Thiết bị nhận tín hiệu Bluetooth trên diện rộng và truyền thông tin vị trí đến hệ thống ORBRO. Hỗ trợ cấp nguồn qua USB-C hoặc PoE, hỗ trợ cả kết nối có dây và không dây (Wi-Fi).',
      price: '300,000',
      img: [{ data: twinTrackerBle1Pop }, { data: twinTrackerBle2Pop }, { data: twinTrackerBle3Pop }],
    },
    {
      title: 'Giá đỡ TwinTracker',
      serial: 'TwinTracker - Bracket',
      desc: 'Giá đỡ gắn TwinTracker lên thanh ray chiếu sáng, giúp lắp đặt dễ dàng.',
      price: '100,000',
      img: [{ data: twinTrackerBracket1Pop }, { data: twinTrackerBracket2Pop }, { data: twinTrackerBracket3Pop }],
    },
    {
      title: 'Thẻ người dùng (UWB)',
      serial: 'Tag-UWB',
      desc: 'Dễ dàng gắn vào người lao động để theo dõi vị trí của họ.',
      price: '60,000',
      img: [{ data: tagUwb1Pop }, { data: tagUwb2Pop }, { data: tagUwb3Pop }],
    },
    {
      title: 'TwinTracker (UWB)',
      serial: 'ORT-TTUW0001',
      desc: 'Nhận tín hiệu UWB trên diện rộng và truyền thông tin vị trí đến nền tảng ORBRO. Độ chính xác dưới 10cm. Hỗ trợ nguồn USB-C và PoE, kết nối có dây và không dây (Wi-Fi).',
      price: '300,000',
      img: [{ data: twinTrackerUwb1 }, { data: twinTrackerUwb2 }, { data: twinTrackerUwb3 }],
    },
  ],
};
